import React from "react"
import MuiLink from "@material-ui/core/Link"
import { Link } from "gatsby-plugin-react-i18next"

export default ({ href, ...otherProps }) => (
  <MuiLink component={Link} to={href} {...otherProps} />
)
